function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#57A6DD;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#221F20;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFCA05;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#00A4DF;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#EE4123;}\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st7{fill:#305692;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#F7A600;}\n\t.st9{fill:#F2F2F2;}\n\t.st10{fill:#FF5F00;}\n\t.st11{fill:#EB001B;}\n\t.st12{fill:#F79E1B;}\n\t.st13{fill:#BC2B2B;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M50.99,40H7.01C3.15,40,0,36.85,0,32.99V7.01C0,3.15,3.15,0,7.01,0h43.98C54.85,0,58,3.15,58,7.01v25.98 C58,36.85,54.85,40,50.99,40z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M12.91,14.8L8.22,25.18h5.61l0.7-1.65h1.59l0.7,1.65H23v-1.26l0.55,1.26h3.2l0.55-1.29v1.29h12.85l1.56-1.61 l1.46,1.61l6.6,0.01l-4.7-5.17l4.7-5.22h-6.5l-1.52,1.58l-1.42-1.58H26.36l-1.2,2.68l-1.23-2.68h-5.6v1.22L17.7,14.8 C17.7,14.8,12.91,14.8,12.91,14.8z M14,16.28h2.74l3.11,7.04v-7.04h3l2.4,5.05l2.21-5.05h2.98v7.45h-1.82l-0.01-5.84l-2.65,5.84 h-1.62l-2.66-5.84v5.84h-3.73l-0.71-1.67h-3.82l-0.71,1.67h-2C10.71,23.72,14,16.28,14,16.28z M32.1,16.28h7.38l2.26,2.44 l2.33-2.44h2.26l-3.43,3.74l3.43,3.7h-2.36l-2.26-2.47l-2.34,2.47H32.1L32.1,16.28L32.1,16.28z M15.33,17.54l-1.26,2.97h2.52 L15.33,17.54z M33.93,17.82v1.36h4.03v1.52h-4.03v1.48h4.52l2.1-2.19l-2.01-2.17L33.93,17.82L33.93,17.82z"
}));

function SvgAmex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 40",
    style: {
      enableBackground: "new 0 0 58 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.86fd4729.svg";
export { ForwardRef as ReactComponent };